import { IBaseCounter } from '../BaseCounter/types'


export interface ICounter extends IBaseCounter {
    co2PerUnit: number;
    actCostsPerUnit: number;
    actPower:number;
    isAlarmLow?: boolean;
    isAlarmHigh?: boolean;
    limitLow?: number;
    limitHigh?: number;
    enableLimitLow: boolean;
    enableLimitHigh: boolean;
    errDelay?: number;
    errSum: boolean;
    enableCounter: boolean;
    inValidCount:number;
    isAlarmValid: boolean;
    isDisabled: boolean;
    onValueChanged: any;
}


export const schema = 'AutomationApps.Devices.Counters.Counter';
export const modelId = 'dtmi:AutomationApps:Devices:Counters:Counter';



